// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WatchlistRouteImport } from './routes/watchlist'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SsoCallbackRouteImport } from './routes/sso-callback'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SellRouteImport } from './routes/sell'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as MyListingsRouteImport } from './routes/my-listings'
import { Route as MessagesRouteImport } from './routes/messages'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AccessibilityRouteImport } from './routes/accessibility'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ListingsIndexRouteImport } from './routes/listings/index'
import { Route as SellersUsernameRouteImport } from './routes/sellers/$username'
import { Route as ListingsIdRouteImport } from './routes/listings/$id'
import { Route as EditIdRouteImport } from './routes/edit/$id'

const WatchlistRoute = WatchlistRouteImport.update({
            id: '/watchlist',path: '/watchlist',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SsoCallbackRoute = SsoCallbackRouteImport.update({
            id: '/sso-callback',path: '/sso-callback',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const SellRoute = SellRouteImport.update({
            id: '/sell',path: '/sell',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const MyListingsRoute = MyListingsRouteImport.update({
            id: '/my-listings',path: '/my-listings',getParentRoute: () => rootRouteImport
          })
const MessagesRoute = MessagesRouteImport.update({
            id: '/messages',path: '/messages',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AccessibilityRoute = AccessibilityRouteImport.update({
            id: '/accessibility',path: '/accessibility',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ListingsIndexRoute = ListingsIndexRouteImport.update({
            id: '/listings/',path: '/listings/',getParentRoute: () => rootRouteImport
          })
const SellersUsernameRoute = SellersUsernameRouteImport.update({
            id: '/sellers/$username',path: '/sellers/$username',getParentRoute: () => rootRouteImport
          })
const ListingsIdRoute = ListingsIdRouteImport.update({
            id: '/listings/$id',path: '/listings/$id',getParentRoute: () => rootRouteImport
          })
const EditIdRoute = EditIdRouteImport.update({
            id: '/edit/$id',path: '/edit/$id',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AccessibilityRoute: AccessibilityRoute,AdminRoute: AdminRoute,MessagesRoute: MessagesRoute,MyListingsRoute: MyListingsRoute,PrivacyRoute: PrivacyRoute,SellRoute: SellRoute,SettingsRoute: SettingsRoute,SsoCallbackRoute: SsoCallbackRoute,TermsRoute: TermsRoute,WatchlistRoute: WatchlistRoute,EditIdRoute: EditIdRoute,ListingsIdRoute: ListingsIdRoute,SellersUsernameRoute: SellersUsernameRoute,ListingsIndexRoute: ListingsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)